export default function title (value) {
	document.title = `${value} | Idicare`
}



// WEBPACK FOOTER //
// ./src/utils/title.js